import React from "react";

//UI Material
import { Card, Grid, Stack } from "@mui/material";

//Helpers
import {
  typographyForMainTitles,
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";
import { selectMonth } from "../../Helpers/date";

//Local components
import AllProductsGraph from "../Graphs/AllProductsGraph";

export default function AllProductsSummary({ data, orders, dark = false }) {
  //Function to display the finished orders of current month
  const getCurrentMonthInfo = () => {
    if (data.month === 0) {
      return typographyForText(`Sin productos en ${selectMonth()}`);
    } else {
      return typographyForText(
        `${data.month} en ${selectMonth()}`,
        null,
        "#26D416"
      );
    }
  };

  // ==========> Component <==========
  return (
    <Card
      raised
      sx={{
        backgroundColor: dark ? "#2A2D3E" : "#003C3C",
        color: "white",
        height: "100%",
      }}
    >
      <Grid
        container
        spacing={1}
        textAlign="center"
        alignItems="center"
        sx={{ padding: "15px" }}
      >
        <Grid item xs={8}>
          <Stack justifyContent="center" alignItems="center">
            {typographyForSubtitles("Producción total", "white")}
            <Stack direction="row" alignItems="center" spacing={1}>
              {typographyForMainTitles(data.total, "white")}
              {typographyForText(`productos`, null, "white")}
            </Stack>
            {getCurrentMonthInfo()}
          </Stack>
        </Grid>
        <Grid item xs={4}>
          <AllProductsGraph data={orders} />
        </Grid>
      </Grid>
    </Card>
  );
}
